import React from 'react'
import styled from 'styled-components'
import { Button } from '@primer-io/goat'

import Clickable from 'components/Clickable'
import Flex from 'ds/Flex'
import { ArrowRight } from '@primer-io/goat-icons'

export const ArrowLinkWrapper = styled(Flex).attrs(() => ({
	flow: 'row wrap',
	justify: 'flex-end',
	gap: '8px 10px',
}))`
	margin-top: 32px;
`

const ArrowLink = ({ as, to, label, icon = 'ArrowRight', ...rest }) => (
	<Button as={as || Clickable} size='small' variant='ghost' to={to} {...rest} style={{ display: 'inline-flex' }}>
		{label}
		<Button.Icon as={ArrowRight} />
	</Button>
)

export default ArrowLink
